import random from 'lodash.random';
import axiosConfig from '../config/axios';

export const checkUsernameAvailability = async ({ username, url }) => {
  const endpointURL = url || '/username_availability';
  try {
    const response = await axiosConfig.get(endpointURL, {
      params: {
        username,
        business_username: username,
      },
    });
    return {
      available: response.data.available,
      username,
      error_message:
        !response.data.available &&
        'username taken. Kindly choose another one or pick from the suggestions',
    };
  } catch (error) {
    return {
      available: null,
      username,
      error_message: error.response.data.error_message,
      statusCode: error.response.status,
    };
  }
};

const generateUsernameSuggestions = async ({
  name,
  phone,
  isInterchangeable,
  url,
}) => {
  const usernameSuggestions = [];

  const nameWithoutSpecialCharacters = name
    ?.replace(/[^_ a-zA-Z 0-9]+/g, '')
    .substr(0, url ? 20 : 15);

  if (nameWithoutSpecialCharacters) {
    const LowerCasedName = nameWithoutSpecialCharacters.toLowerCase();
    if (nameWithoutSpecialCharacters.indexOf(' ') > 0) {
      await checkUsernameAvailability({
        username: LowerCasedName.replace(/\s/g, ''),
        url,
      }).then(data => {
        if (data.available) {
          usernameSuggestions.push(data.username);
        }
      });

      await checkUsernameAvailability({
        username: LowerCasedName.replace(/\s/g, '_'),
        url,
      }).then(data => {
        if (data.available) {
          usernameSuggestions.push(data.username);
        }
      });

      if (isInterchangeable) {
        const nameList = LowerCasedName.split(/\s+/).reverse();

        await checkUsernameAvailability({
          username: LowerCasedName.split(/\s+/)[0],
          url,
        }).then(data => {
          if (data.available) {
            usernameSuggestions.push(data.username);
          }
        });

        await checkUsernameAvailability({
          username: nameList.join(''),
          url,
        }).then(data => {
          if (data.available) {
            usernameSuggestions.push(data.username);
          }
        });

        await checkUsernameAvailability({
          username: nameList.join('_'),
          url,
        }).then(data => {
          if (data.available) {
            usernameSuggestions.push(data.username);
          }
        });
      }
    } else {
      await checkUsernameAvailability({
        username: LowerCasedName,
        url,
      }).then(data => {
        if (data.available) {
          usernameSuggestions.push(data.username);
        }
      });
    }
  }

  if (phone && phone.length > 11) {
    await checkUsernameAvailability({ username: phone, url }).then(data => {
      if (data.available) {
        usernameSuggestions.push(data.username);
      }
    });
  }

  if (nameWithoutSpecialCharacters && usernameSuggestions.length < 1) {
    const generateUsernameWithNumbers = async () => {
      const randomNumber = random(1, 1000);
      const usernameWithNumbers = `${nameWithoutSpecialCharacters
        .toLowerCase()
        .replace(/\s/g, '')
        .substr(0, 17)}${randomNumber}`;
      await checkUsernameAvailability({
        username: usernameWithNumbers,
        url,
      }).then(data => {
        if (data.available) {
          usernameSuggestions.push(data.username);
        } else if (data.statusCode === 200) {
          generateUsernameWithNumbers();
        }
      });
    };

    await generateUsernameWithNumbers();
  }

  return usernameSuggestions;
};

export default generateUsernameSuggestions;
